const getMetaTranslations = (state) => state.ws.template.meta.translations;

export default getMetaTranslations;
